export const useEditorLayerMetrics = ({ layerCompData, layerSequence }) => {
  const getHeightestZindex = () => {
    if (layerCompData.length > 0) {
      let data = [...layerCompData];

      data.sort((a, b) =>
        a.componentStyles.zIndex >= b.componentStyles.zIndex ? 1 : -1,
      );
      return data[data.length - 1].componentStyles.zIndex + 1;
    }
    return 1;
  };

  const getMaxlayerNameCount = (type) => {
    const newLayerdata = layerSequence(type);
    if (newLayerdata.length <= 0) {
      return;
    }
    const layerCountdata = [];
    newLayerdata?.forEach((item) => {
      layerCountdata.push(item.componentStyles.layerName);
    });
    let final = [];

    layerCountdata.forEach((item) => {
      const text = item?.split(type).join("");
      final.push(parseInt(text));
    });

    const newArray = final.filter((value) => !Number.isNaN(value));
    let maxNumber;
    if (newArray.length > 0) {
      maxNumber = Math.max(...newArray);
    } else {
      maxNumber = 0;
    }

    return maxNumber;
  };

  return {
    getHeightestZindex,
    getMaxlayerNameCount,
  };
};
